import HeaderText from 'components/shared/header-text';
import DescriptionEntry from 'components/shared/description-entry';

import { aboutCss } from 'data/css/about.js';

const AboutTab = () => (
  <div className="tab-view">
    <HeaderText
      fontSize="30px"
      text="About CSS"
      fontWeight="bold"
      margin="0 0 40px 0"
    />
    <div className="inner-tab-content">
      {aboutCss?.items?.map((entry) => (
        <DescriptionEntry entry={entry} key={entry?.title} width="80%" />
      ))}
    </div>
  </div>
);

export default AboutTab;
